var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWorldZoom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.18 10 4.106 4.435v.926c0 1.023.767 1.852 1.714 1.852V19c-3.386-.454-6-3.565-6-7.343 0-.574.069-1.13.18-1.657zm9.237-5C17.102 6.106 19 8.797 19 11.947c0 1.95-.733 3.722-1.925 5.053-.238-.75-.926-1.303-1.742-1.303h-.916v-2.813a.927.927 0 0 0-.917-.937H8v-1.875h1.833c.507 0 .917-.42.917-.938V7.26h1.833c1.013 0 1.834-.84 1.834-1.875V5zM12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM1 19a1 1 0 0 1 1 1v2h2a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1zm22 0a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1 0-2h2v-2a1 1 0 0 1 1-1zM4 0a1 1 0 1 1 0 2H2v2a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1zm19 0a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V2h-2a1 1 0 0 1 0-2h3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWorldZoom);
export default __webpack_public_path__ + "static/media/icon_world_zoom.b20e754a6ed88aeac4f4f32d36d92650.svg";
export { ForwardRef as ReactComponent };